<template>
  <div class="details">
    <HeaderReturn title="通证管理记录"></HeaderReturn>
    <div class="property">
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 34px;
          text-align: right;

          color: var(--unnamed, #f89b19);
        "
      >
        订单编号:{{ Aeccter.orderId }}
      </p>

      <div class="details_grid">
        <ul>
          <li>
            <span class="fn-12">通证额度</span>
            <div class="fn-12" style="margin-left: 11px">
              {{ Aeccter.passLimit }}
            </div>
            
          </li>
          <li>
            <span class="fn-12">累计发放收益(已释放)</span>
            <div class="fn-12" style="margin-left: 11px">
              {{ Aeccter.addUpRelease }}
            </div>
            
          </li>
        </ul>
        <ul>
          <li>
            <span class="fn-12">消耗USDT2</span>
            <div class="fn-12" style="margin-left: 11px">
              {{ Aeccter.consumeLqd2 }}
            </div>
            
          </li>
          <li>
            <span class="fn-12">消耗LQD</span>
            <div class="fn-12" style="margin-left: 11px">
              {{ Aeccter.consumeLqd }}
            </div>
            
          </li>
        </ul>
        <ul>
          <li>
            <span class="fn-12">认购时间</span>
            <div
              style="
                margin-left: 11px;
                /* color: #003e62; */
                /* font-weight: 400; */
                /* font-size: 14px; */
                line-height: 22px;
              "
            >
            
              {{ Aeccter.createTime | dateFormat }}
            </div>
            
          </li>
          <li>
            <span class="fn-12">认购金额</span>
            <div class="fn-12" style="margin-left: 11px">
              {{ Aeccter.subAmount }}
            </div>
            
          </li>
        </ul>
      </div>
    </div>
    <div class="details_finance d-flex">
      <div>
        <img src="../../assets/img/page/j3.png" alt="" />
      </div>
      <div>释放明细</div>
    </div>
    <div class="details_ul">
      <ul>
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <li v-for="(item, index) in AccasetList" :key="item.id">
            <div class="d-flex justify-between">
              <p style="color: var(--unnamed, #00C480);">
                <span v-if="item.amount>0" style="color: var(--unnamed, #00C480);">+</span>
                <span v-else style="color: var(--unnamed, red);">-</span>
                {{ item.amount }}
              </p>

              <p>
                {{ item.createTime | dateFormat }}
              </p>
            </div>
          </li>
        </van-list>
      </ul>
    </div>
    <!-- <div class="details_btn">
            <div class="d-flex" @click="goLink('/My/recharge')">
                <img src="../../assets/img/page/j2.png" alt="">
                <span>充币</span>
            </div>
            <div class="d-flex">
                <img src="../../assets/img/page/j1.png" alt="">
                <span>转账</span>
            </div>
        </div> -->
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      Aeccter: {
        money: 75.8193,
      },
      TeamList: [
        {
          txt: "可用余额",
        },
        {
          txt: "冻结",
        },
      ],
      AccasetList: [],
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 10,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.Aeccter = JSON.parse(this.$route.query.item);
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.pageNo++;
      let parme = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderId: this.Aeccter.orderId,
      };
      mainApiData.Detailed(parme).then((res) => {
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.records.length; i++) {
            this.AccasetList.push(res.data.data.records[i]);
          }
          this.total = res.data.total;
        }
      });
      this.loading = false;
      if (this.AccasetList.length >= this.total) {
        this.finished = true;
      }
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path) {
      if (path) {
        this.$router.push({
          path,
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}

.details {
  margin: 50px 10px;

  ::v-deep .van-nav-bar__title {
    color: #fff;
  }

  .details_finance {
    margin: 40px 10px 10px 10px;

    div {
      img {
        width: 100%;
        height: 100%;
      }

      &:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        text-align: center;
        margin-left: 10px;

        /* 黄/主题 */

        color: #f89b19;
      }
    }
  }

  .property {
    // width: 90%;
    margin: 15px 10px;

    // height: 122px;

    // background: url(../../assets/img/page/hh.png) no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;

    border: 1px solid #f89b19;
    ::v-deep .number-grow {
      color: #f89b19 !important;
      font-size: 20px;
    }

    ::v-deep .number-grows {
      color: #fff !important;
      font-size: 16px;
      margin-top: 3px;
      display: block;
    }

    p {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      /* 白/FE */

      color: #fefefe;

      &:nth-child(1) {
        padding: 10px 10px 0 10px;

        // ::v-deep .numsp {

        //     font-size: 15px !important;
        //     border: 1px solid red;
        // }
      }

      span {
        color: #fff;
        font-size: 18px;
      }

      &:nth-child(2) {
        padding: 5px 10px 0 10px;
      }

      ::v-deep .numsp {
        color: #f89b19;
        font-size: 13px !important;
        // border: 1px solid red;
      }
    }
  }

  .details_grid {
    ul {
    //   display: flex;
      // justify-content:space-around;
      // grid-template-columns: 50% 50% ;
      text-align: center;
      

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 12px;
        padding: 10px 0;
        margin-bottom: 10px;
        // margin-top: 17px;

        div {
        //   color: #fff;
          font-family: "PingFang SC";
          font-style: normal;
        //   font-weight: 400;
        //   font-size: 18px;
          color: #f89b19;
          line-height: 22px;

          color: var(--unnamed, #f89b19);
            font-size: 16px;
            margin-right: 10px;
        }

        font-family: "PingFang SC";
        font-style: normal;
        // font-weight: 400;
        font-size: 12px;
        line-height: 22px;

        span {
          // padding: 8.74px 0px 15px 0;
          color: var(--fe, #fefefe);
          font-size: 14px;
          margin-left: 10px;
        }

        &:nth-child(1) {
          text-align: left;
        }

        &:nth-child(2) {
          text-align: left;
        }
      }
      

      // align-items: center;
    }
    // ul:last-child{
    //     margin-bottom: 20px;
    //   }
  }

  .details_ul {
    ul {
      overflow: hidden;
      overflow-y: scroll;
      height: 350px;
      li {
        margin: 20px 10px;
  

        /* 黄/主题 */

        // border: 0.5px solid #f89b19;
        border: 1px solid #f89b19;
 

        border-radius: 4px;

        div {
          &:nth-child(1) {
            padding: 10px 15px;

            p {
              font-style: normal;
              font-weight: 400;
              font-size: 18px;
              line-height: 25px;
              text-align: center;

              // color: #FFFFFF;

              &:nth-child(1) {
                font-family: "PingFang SC";
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 25px;
                text-align: center;

                // color: #FFFFFF;
              

                span {
                  font-size: 16px;
                  color: #999999;
                }
              }

              &:nth-child(2) {
                font-family: "PingFang SC";
                font-style: normal;
                font-weight: 400;
                // font-size: 13px;
                line-height: 25px;
                text-align: center;
                color: #939393;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  .details_btn {
    padding: 112px 0 35px 0;
    display: grid;
    justify-content: space-between;
    grid-template-columns: 45% 45%;
    // align-items: center;

    div {
      &:nth-child(1) {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;

        /* 黄/主题 */

        background: #f89b19;
        border-radius: 4px;
        color: #fefefe;
      }

      &:nth-child(2) {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;

        /* 黄/主题 */

        /* 黄/主题 */

        border: 0.5px solid #f89b19;
     
        border-radius: 4px;

        color: #fefefe;
      }
    }
  }
}
</style>
